import React, { useState } from "react";
import { Helmet } from "react-helmet-async";

import Subheader from "../../components/UI/Subheader/Subheader";
import CollaboratorEdit from "../../components/Collaborator/CollaboratorEdit/CollaboratorEdit";

function CollaboratorEditScreen() {
  const [updatedAt, setUpdatedAt] = useState(undefined);
  const setSubheaderUpdatedAt = (date) => {
    setUpdatedAt(date);
  };

  return (
    <>
      <Helmet>
        <title>Dados do Colaborador</title>
      </Helmet>
      <Subheader title="Busca | Dados do Colaborador" updatedAt={updatedAt} />

      <CollaboratorEdit setSubheaderUpdatedAt={setSubheaderUpdatedAt} />
    </>
  );
}

export default CollaboratorEditScreen;
